import {combineReducers, createStore} from "redux";
import {loginType} from "./Reducers";
import states from "./States";

const rootReducers = combineReducers({loginType})
const initState = {
    loginType: states.loginType,
}
// 全局就管理一个store
export const store = createStore(rootReducers, initState)